import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface LoaderState {
  isLoading: boolean;
  _count: number;
  showLoader: (val: boolean) => void;
  resetLoader: () => void;
}

const useLoaderStore = create<LoaderState>()(
  devtools((set, get) => ({
    isLoading: false,
    _count: 0,

    showLoader: (val: boolean) => {
      const count = get()._count;
      if (val) {
        const next = count + 1;
        set({ _count: next, isLoading: true });
      } else {
        const next = Math.max(0, count - 1);
        set({ _count: next, isLoading: next > 0 });
      }
    },

    resetLoader: () => set({ _count: 0, isLoading: false }),
  }))
);

export default useLoaderStore;
